module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: {
      fullWidth: _vm.fullWidth
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xs": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    class: [("order-md-" + _vm.order1), 'order-1'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order1
    }
  }, [_c('div', {
    staticClass: "text-container dflex justify-center align-center flex-column"
  }, [_c('h3', {
    staticClass: "mb-5"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + " "), _c('br'), _vm._v("\n            " + _vm._s(_vm.title2) + "\n\n            "), (_vm.ctaText) ? _c('span', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "cta_btn",
    attrs: {
      "href": _vm.ctaAction
    }
  }, [_vm._v(_vm._s(_vm.ctaText))])]) : _vm._e()])])]), _vm._v(" "), _c('v-flex', {
    class: [("order-md-" + _vm.order2), 'order-2'],
    attrs: {
      "xs12": "",
      "md6": "",
      "order": _vm.order2
    }
  }, [_c('div', {
    staticClass: "img-container dflex justify-center align-center cover-x-space"
  }, [_c('img', {
    class: {
      fullWidth: _vm.fullWidth,
      bigImage: _vm.bigImage,
      moneyImage: _vm.moneyImage,
    },
    attrs: {
      "src": _vm.imgSrc
    }
  })])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e17cad06","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing1/CRow.vue
// module id = 1856
// module chunks = 180